


























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import RechargeCardApi from '@/api/marketing/rechargeCard/index'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
@Component({
  components: {
    PicModal,
  },
})
export default class RechargeCard extends AbpBase {
  currentTab: string = 'basicForm'
  activityId: string = ''
  addrecharge: boolean = false
  automaticCardModal: boolean = false
  autoInputValue: number = null
  totalCount: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  columns: any[] = [
    {
      title: '卡号',
      key: 'name',
      align: 'center',
    },
    {
      title: '密码',
      key: 'value',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  addRechargeText: string = ''
  formItem = {
    name: '',
    beginTime: null,
    endTime: null,
    code: '',
    amount: null,
    imgUrl: '',
    isPublish: false,
    items: [],
  }
  ruleValidate = {
    name: [{ required: true, message: '活动标题不能为空', trigger: 'blur' }],
    code: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
    amount: [{ required: true, message: '面额不能为空', trigger: 'blur' }],
    beginTime: [
      {
        required: true,
        validator: this.validBeginTime,
        trigger: 'change',
      },
    ],
    endTime: [
      {
        required: true,
        validator: this.validEndTime,
        trigger: 'change',
      },
    ],
  }
  picChange(e) {
    console.log(e)
    this.formItem.imgUrl = e[0].url
  }
  validBeginTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择开始日期'))
    } else {
      ;(this.$refs as any).basicForm.validateField('endTime')
    }
    callback()
  }
  deleteRecharge(index) {
    this.formItem.items.splice(index, 1)
  }
  validEndTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择结束日期'))
    }
    if (value < this.formItem.beginTime) {
      callback(new Error('结束日期必须大于开始日期'))
    }
    callback()
  }
  cancelFn() {
    this.addrecharge = false
    this.addRechargeText = ''
  }
  saveFn() {
    if(this.addRechargeText.trim() == '') {
      this.$Notice.warning({
        title: '卡密输入不能为空'
      })
      return
    }
    let arr = this.addRechargeText.split(/[(\r\n)\r\n]+/)
    let arr1 = []
    if(arr.length) {
      arr1 = arr.map(item => {
        return {
          name: item.split(' ')[0],
          value: item.split(' ')[1],
        }
      })
    }
    console.log(arr1);
    this.formItem.items = this.removal(this.formItem.items.concat(arr1))
    this.addrecharge = false
    this.addRechargeText = ''
  }
  saveAutoFn() {
    if(!this.autoInputValue) {
      this.$Notice.warning({
        title: '生成的卡密条数不能为空'
      })
      return
    }
    RechargeCardApi.autoGenerate(this.autoInputValue).then(res => {
      console.log('自动卡密', res);
      this.$Notice.success({
        title: '生成成功'
      });
      this.automaticCardModal = false;
      this.autoInputValue = null;
      this.formItem.items = this.removal(this.formItem.items.concat(res.data.items))
    })
  }
  removal(arr) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if(arr[i].name == arr[j].name && arr[i].value == arr[j].value) {
          arr.splice(j, 1);
          j--;
        }        
      }
    }
    return arr
  }
  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
  }
  save() {
    var valid1 = (this.$refs['basicForm'] as any).validate()
    var valid2 =
      (this.$refs['ruleConfigForm'] as any).rules === null
        ? new Promise((resolver) => resolver(true))
        : (this.$refs['ruleConfigForm'] as any).validate()
    Promise.all([valid1, valid2]).then((values) => {
      var index = values.findIndex((x) => x === false)
      if (index > -1) {
        if (index === 0) this.currentTab = 'basicForm'
        if (index === 1) this.currentTab = 'ruleConfigForm'
      } else {
        if (this.activityId) {
          RechargeCardApi.updateDetail(this.activityId, this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'rechargeCard',
            })
          })
        } else {
          console.log(this.formItem)
          RechargeCardApi.createChargeCard(this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'rechargeCard',
            })
          })
        }
      }
    })
  }
  created() {
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString()
      this.loadActivity()
    }
  }
  loadActivity() {
    RechargeCardApi.getDetail(this.activityId).then((res) => {
      console.log('卡密活动', res);
      this.formItem = res.data
      this.formItem.beginTime = new Date(res.data.beginTime)
      this.formItem.endTime = new Date(res.data.endTime)
    })
  }
}
